


export const TimeSeriesDataProcess = () => {
  if(typeof window.__GTM_DOCS__ !== 'undefined'){
    let rawTags = window.__GTM_DOCS__.container.tag;
    let rawTriggers = window.__GTM_DOCS__.container.trigger;
    let rawVariables = window.__GTM_DOCS__.container.variable;
    let dailyCount = {};

    if(typeof rawTags !=='undefined'){
      rawTags.forEach((tag)=>{
        let date = new Date(parseInt(tag.fingerprint));
        let indexDateString = date.getDate()+" "+date.toLocaleString('default', { month: 'long' })+' '+date.getFullYear();
        let indexDate = new Date (indexDateString);

        dailyCount[indexDate] =  dailyCount[indexDate] || {"tag":0 , "variable":0, "trigger":0};
        dailyCount[indexDate].name = indexDateString;
        dailyCount[indexDate].tag += 1;
      });
    }
    if(typeof rawVariables !=='undefined'){
      rawVariables.forEach((tag)=>{
        let date = new Date(parseInt(tag.fingerprint));
        let indexDateString = date.getDate()+" "+date.toLocaleString('default', { month: 'long' })+' '+date.getFullYear();
        let indexDate = new Date (indexDateString);

        dailyCount[indexDate] =  dailyCount[indexDate] || {"tag":0 , "variable":0, "trigger":0};
        dailyCount[indexDate].name = indexDateString;
        dailyCount[indexDate].variable += 1;
      });
    }
    if(typeof rawTriggers !=='undefined'){
      rawTriggers.forEach((tag)=>{
        let date = new Date(parseInt(tag.fingerprint));
        let indexDateString = date.getDate()+" "+date.toLocaleString('default', { month: 'long' })+' '+date.getFullYear();
        let indexDate = new Date (indexDateString);

        dailyCount[indexDate] =  dailyCount[indexDate] || {"tag":0 , "variable":0, "trigger":0};
        dailyCount[indexDate].name = indexDateString;
        dailyCount[indexDate].trigger += 1;
      });
    }

    // Converts Object into Array
    let list = Object.keys(dailyCount).map(keys=>{
      let obj = dailyCount[keys];
      obj.stamp = keys;
      return obj;
    });

    //console.log(list);

    let newList = list.sort(function(a,b){
      return new Date(a.stamp) - new Date(b.stamp);
    });

    return newList;
  }
}
